import { SocieteLinkedModel } from './../../../shared/models/societe-linked/societe-linked.model';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BcModel } from './../../../shared/models/societe-linked/bc/bc.model';
import { FournisseurModel } from './../../../shared/models/societe-linked/fournisseur.model';
import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { BpValidationModel } from './../../../shared/dtos/bpValidationModel';
import { startWith, map, debounceTime, switchMap } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FilterBpDTO } from 'src/app/shared/dtos/filterBpDTO';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { StateService } from 'src/app/shared/services/state.service';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';
import { Ca2Service } from 'src/app/shared/services/societe-linked/ca2.service';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { Title } from '@angular/platform-browser';
import { FiltreService } from '../../filtre.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { ModalChargementComponent } from 'src/app/shared/components/modals/modal-chargement/modal-chargement.component';
import { Router } from '@angular/router';
import { ModalRechercheFournisseurComponent } from '../../bc/modals/modal-recherche-fournisseur/modal-recherche-fournisseur.component';
import { GenericLibelleService } from 'src/app/shared/services/basic/generic-libelle.service';
import { BasicModel } from 'src/app/shared/models/basic/basic.model';
import { saveAs } from 'file-saver';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';

@Component({
  selector: 'app-liste-bp',
  templateUrl: './liste-bp.component.html',
  styleUrls: ['./liste-bp.component.scss']
})
export class ListeBpComponent implements OnDestroy {

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });
  bpForm: UntypedFormGroup;
  societes: SocieteModel[];
  sites: SiteModel[];
  ca1s: Ca1Model[];
  ca2s: Ca2Model[];
  nasStart: NaModel[];
  nasEnd: NaModel[];
  bcsEnd: BcModel[];
  bcsStart: BcModel[];
  bpsEnd: BpModel[];
  bpsStart: BpModel[];
  users: UtilisateurModel[] = [];
  validators: UtilisateurModel[] = [];
  fournisseurs: FournisseurModel[];
  myOpenOrderCount = 0;

  filteredOptions: Observable<string[]>;
  bpList: BpModel[];
  title = 'Liste des factures';
  user: string;
  myControl = new UntypedFormControl();
  filtreData: FilterBpDTO = new FilterBpDTO();
  society: SocieteModel;
  private filteredSubscribe: any;
  public FlagEnum = NTHFlag;
  listStatus = ['Rapproché', 'En litige', 'Clos'];
  listStatusUpdated = new BehaviorSubject<string[]>(this.listStatus);
  selectedBpsChild: BpModel[] = [];
  isListAValide = false;
  simpleQueryBpResponse = new SimpleQueryResponse<BpModel>();
  
  constructor(
    public dialog: MatDialog,
    public naService: NaService,
    public ca1Service: Ca1Service,
    public ca2Service: Ca2Service,
    public bpService: BpService,
    public bcService: BcService,
    private titleService: Title,
    private userService: UserService,
    public fournisseurService: FournisseurService,
    public siteService: SiteService,
    private societeService: SocieteService,
    private state: StateService,
    private filtreService: FiltreService,
    private router: Router,
    private detector: ChangeDetectorRef) {
    this.state.society.subscribe(result => {
      this.society = result;
      if (result) {
        this.filtreData.idSociete = this.society.id;
      }
    });
    this.state.user.subscribe(result => {
      this.user = result;
    });


    this.filteredSubscribe = this.filtreService.filtreBp.pipe(debounceTime(700),
      switchMap(result => {
        this.filtreData = result;
        this.listStatusUpdated.next(result.status);
  
        this.title = 'Liste des factures ';
        switch (this.filtreData.type) {
          case 'v_traite_recemment': {
            this.title = this.title + 'réceptionnées récemment';
            this.isListAValide = false;
            break;
          }
          case 'v_bloques': {
            this.title = this.title + 'bloqués';
            this.isListAValide = false;
            break;
          }
          case 'v_non_paye': {
            this.title = this.title + 'non payées';
            this.isListAValide = false;
            break;
          }
          default: {
            this.title = this.title + '';
            this.isListAValide = false;
          }
        }
        return this.bpService.getFiltredBp(this.filtreData);
      })
    ).subscribe((data: SimpleQueryResponse<BpModel>) => {
      this.simpleQueryBpResponse = data;
      this.bpList = data.objets;
    });
    this.titleService.setTitle('SACHA - Liste facture ');
  }

  onChange(event): void {
    this.filtreData.pageNumber = 0;
    this.filtreService.changeFiltreBP(this.filtreData);
  }
  onStatusChange(event): void {
    this.filtreData.status = event;
    this.filtreData.pageNumber = 0;
    this.filtreService.changeFiltreBP(this.filtreData);
  }

  clearFiltre(): void {
    const type = this.filtreData.type;
    this.filtreData = new FilterBpDTO();
    this.filtreData.type = type;
    this.filtreService.changeFiltreBP(this.filtreData);
  }

  ngOnDestroy(): void {
    this.filteredSubscribe.unsubscribe();
  }

  load(): void {
    this.societeService.getAllForBp().subscribe(objs => this.societes = objs);
    this.userService.getAllValideur('BC').subscribe(objs => this.validators = objs);
    this.userService.getAllCreateur('BC').subscribe(objs => this.users = objs);
  }

  loadData(value: string, service: GenericLibelleService<BasicModel>, modelString: string): void {
    if (value) {
      service.getAllFiltred(value, this.filtreData.societe ? this.filtreData.societe.id : null).subscribe(objs => {
        this[modelString] = objs;;
      });
    } else {
      this[modelString] = [];
    }
    this.detector.detectChanges();
  }

  getSelectedBps(event: BpModel[]): void {
    this.selectedBpsChild = event;
  }

  validation(): Observable<number> {
    let i = 0;
    const nb = new BehaviorSubject<number>(0);
    for (const bp of this.selectedBpsChild) {
      const bpvalidator: BpValidationModel = new BpValidationModel();
      bpvalidator.bp = bp;
      bpvalidator.commentaire = '';
      this.bpService.validateBp(bpvalidator).subscribe(_ => {
        i++;
        nb.next(i);
      });
    }
    return nb.asObservable();
  }

  onValidationBps(): void {
    const dialogRef = this.dialog.open(ModalChargementComponent, {
      disableClose: true,
      data: {
        observable: this.validation(),
        total: this.selectedBpsChild.length,
        result: true
      }
    });
    dialogRef.afterClosed().subscribe(_ => {
      this.router.navigate(['/']);
    });
  }

  openModalFournisseur(): void {
    this.dialog.open(ModalRechercheFournisseurComponent, {
      disableClose: true,
      data: {
        idSociete: this.filtreData.idSociete
      }
    }).afterClosed().subscribe((res: FournisseurModel) => {
      if (res) {
        this.filtreData.bpFourn = res;
        this.filtreData.pageNumber = 0;
        this.onChange(res.code + "-" + res.libelle)
      }
    });
  }

  onExport(): void {
    const dialogRef = this.dialog.open(SpinnerModalComponent);
    this.bpService.exportBps(this.filtreData).subscribe((res: BlobPart)  => {
      const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), res], {type: 'text/csv;charset=utf-8'});
      saveAs(blob, 'Export_BP_' + new Date().toISOString() + '.csv');
      dialogRef.close();
    }, (error) => dialogRef.close());
  }

}
